import { isDev, isStaging } from 'app/utils/envUtil';

let frontEndPath = 'https://picoxia.com';
if (isDev()) {
  frontEndPath = 'http://localhost:3000';
} else if (isStaging()) {
  frontEndPath = 'https://staging.picoxia.com';
}
export const FRONT_END_PATH = frontEndPath;
